var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rb-file-attachment" }, [
    _c("input", {
      directives: [
        { name: "show", rawName: "v-show", value: false, expression: "false" },
      ],
      key: _vm.fileInputKey,
      ref: "fileAttachment",
      attrs: {
        id: "rbContactUsfileAttachment",
        type: "file",
        name: "rbContactUsfileAttachment",
      },
      on: { change: _vm.onFileInputChange },
    }),
    _vm._v(" "),
    _c("label", { staticClass: "rb-file-attachment__label" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.translation("get_support.contact_us_form.attachment")) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "rb-file-attachment--first-row" }, [
      !_vm.isFileAdded
        ? _c(
            "label",
            {
              staticClass:
                "rb-file-attachment__choose-label rb-btn rb-btn--white",
              attrs: { for: "rbContactUsfileAttachment" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.translation("get_support.contact_us_form.choose_file")
                  ) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isFileAdded
        ? _c("div", { staticClass: "rb-file-details" }, [
            _vm.isFileIconVisible
              ? _c("span", {
                  staticClass: "common__icon",
                  class: _vm.fileInputIconClass,
                })
              : _vm._e(),
            _vm._v(" "),
            _c("label", { staticClass: "rb-file-attachment__name" }, [
              _vm._v("\n        " + _vm._s(_vm.attachmentName) + "\n      "),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "rb-file-attachment__size" }, [
              _vm._v("\n        " + _vm._s(_vm.getAttachmentSize) + "\n      "),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isFileAdded
        ? _c("div", { staticClass: "rb-file-links" }, [
            _c(
              "label",
              {
                staticClass: "rb-file-links__change-label",
                attrs: { for: "rbContactUsfileAttachment" },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.translation("get_support.contact_us_form.change_file")
                    ) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "rb-file-links__remove-btn",
                on: { click: _vm.onFileRemove },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.translation("get_support.contact_us_form.remove_file")
                    ) +
                    "\n      "
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.canShowFileInputErrorMessage
      ? _c("div", { staticClass: "rb-file-attachment--second-row" }, [
          _c("label", { staticClass: "rb-file-attachment__error-message" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.translation("get_support.contact_us_form.error_file")
                ) +
                "\n    "
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }